const features = [
  {
    id: 1,
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式阅读',
    desc: '独创下拉式漫画阅读体验，无需翻页，一气呵成。手指轻滑即可连续阅读，沉浸感十足。',
  },
  {
    id: 2,
    icon: 'ri-database-2-line',
    title: '海量漫画库',
    desc: '收录数万部星际漫画、科幻漫画与宇宙漫画，涵盖星际战争、太空冒险、外星文明等丰富题材。',
  },
  {
    id: 3,
    icon: 'ri-speed-up-line',
    title: '每日极速更新',
    desc: '热门连载作品保持每周至少一话的更新频率，部分作品实现日更，让你追更不停。',
  },
  {
    id: 4,
    icon: 'ri-contrast-2-line',
    title: '高清画质优化',
    desc: '所有漫画均经过高清画质优化处理，支持多种阅读模式，保护你的视力同时保证画面细节。',
  },
  {
    id: 5,
    icon: 'ri-device-line',
    title: '全平台适配',
    desc: '完美适配桌面、平板和手机等多端设备，一账号同步阅读进度，随时随地无缝切换。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            为什么百万读者选择星球漫画
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 rounded-lg p-4 md:p-5 border border-background-200/60 text-center"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 md:mb-4 rounded-full bg-accent-50 flex items-center justify-center">
                <i className={`${feature.icon} text-accent-500 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}